import { render, staticRenderFns } from "./removebutton.vue?vue&type=template&id=e99ddbb2&scoped=true&"
import script from "./removebutton.vue?vue&type=script&lang=js&"
export * from "./removebutton.vue?vue&type=script&lang=js&"
import style0 from "./removebutton.vue?vue&type=style&index=0&id=e99ddbb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99ddbb2",
  null
  
)

export default component.exports